import { DbCommon } from "../constants/dbCommon";
import { Alert } from "./alert";
import { PassEncryption } from "./encryption";

export class AgentLoginCredentials {
    username: string;
    password: string;
    adminDirectSystem: string;
    agentCity: string;
    agentState: string;
    reCaptchaID?: number;
    reCaptchaToken?: string;
    isPortal: boolean;
    passEncryption: PassEncryption

    constructor() {
        this.username = null;
        this.password = null;
        this.adminDirectSystem = null;
        this.agentCity = null;
        this.agentState = null;
        this.reCaptchaID = null;
        this.reCaptchaToken = null;
        this.isPortal = true;
        this.passEncryption = new PassEncryption()
    }
}

export class AgentLogin {
    agent: Agent;

    constructor() {
        this.agent = null;
    }
}

export class Agent {
    agentID: number;
    name: string;
    canCreateMembers: boolean;
    canAccessCRM: boolean;
    mustResetPassword: boolean;
    isSupervisor: boolean;
    dashboardTemplate: string;
    hasAccessToAllBrokers: boolean;
    brokerID: number;
    accessToken: string;
    refreshToken: string;
    adminDirectSystem: string;
    agentCity: string;
    agentState: string;
    brokerImagePath: string;
    isCodeVerfied: boolean;
    errorMessage: string;
    cellPhone: string;
    phoneNumber: string;
    isCellPhoneMFAConfigured: boolean;
    isQRMFAConfigured: boolean;

    constructor() {
        this.agentID = null;
        this.name = null;
        this.canCreateMembers = false;
        this.canAccessCRM = false;
        this.mustResetPassword = false;
        this.isSupervisor = false;
        this.dashboardTemplate = null;
        this.hasAccessToAllBrokers = false;
        this.brokerID = 0;
        this.accessToken = null;
        this.refreshToken = null;
        this.adminDirectSystem = null;
        this.agentCity = null;
        this.agentState = null;
        this.brokerImagePath = null;
        this.isCodeVerfied = false;
        this.errorMessage = null;
        this.cellPhone = null;
        this.phoneNumber = null;
        this.isCellPhoneMFAConfigured = false;
        this.isQRMFAConfigured = false;
    }
}

export class AgentCompanyList {
    agentCompanies: AgentCompany[];

    constructor() {
        this.agentCompanies = new Array<AgentCompany>();
    }
}

export class AgentCompany {
    companyID: number;
    code: string;
    companyName: string;
    isSelected: boolean;

    constructor() {
        this.companyID = null;
        this.code = null;
        this.companyName = null;
        this.isSelected = false;
    }
}

export class AgentMemberSearchHistory {
    matchingMembers: AgentMemberSearchResult[];

    constructor() {
        this.matchingMembers = new Array<AgentMemberSearchResult>();
    }
}

export class AgentMemberSearchResult {
    systemNumber: number;
    firstName: string;
    lastName: string;
    status: string;
    ssn: string;
    companyName: string;
    employeeID: string;
    payrollNumber: string;
    homeEmail: string;
    homePhone: string;
    birthDate: string;
    memberName: string;
    isVerified: boolean;

    constructor() {
        this.systemNumber = null;
        this.firstName = null;
        this.lastName = null;
        this.status = null;
        this.ssn = null;
        this.companyName = null;
        this.employeeID = null;
        this.payrollNumber = null;
        this.homeEmail = null;
        this.homePhone = null;
        this.birthDate = null;
        this.memberName = null;
        this.isVerified = false;
    }
}

export class AgentMemberLogin {
    agentID: number;
    homeEmail: string;
    homePhone: string;
    systemNumber: number;

    constructor() {
        this.agentID = null;
        this.homeEmail = null;
        this.homePhone = null
        this.systemNumber = null;
    }
}

export class AgentMemberLoginResponse {
    isEnrollmentAvailableForMember: boolean;
    companyImagePath: string;
    dashboardTemplate: string;
    showDependentVerification: boolean;
    showLifeEventVerification: boolean;
    showMemberAccounting: boolean;
    requireDependentVerificationDocuments: boolean;
    isVbo: boolean;
    dontRequireSpouseSSN: boolean;
    hasSSN: boolean;
    showMemberWaiveDocuments: boolean;
    showWaiveDocuments: boolean;
    enrollmentCategoryModelVBO: boolean;
    isUSAePayEnabled: boolean;
    useACAModule: boolean;
    usePayrollModule: boolean;
    useYearRound: boolean;
    availablePTO: string;
	availableSickTime: string;
    messageCenterAlerts: Alert[];
    divisionCaption: string;
	division: string;
	email: string;

    constructor() {
        this.isEnrollmentAvailableForMember = false;
        this.companyImagePath = null;
        this.dashboardTemplate = null;
        this.showDependentVerification = false;
        this.showLifeEventVerification = false;
        this.showMemberAccounting = false;
        this.requireDependentVerificationDocuments = false;
        this.isVbo = false;
        this.dontRequireSpouseSSN = false;
        this.hasSSN = false;
        this.showMemberWaiveDocuments = false;
        this.showWaiveDocuments = false;
        this.enrollmentCategoryModelVBO = false;
        this.isUSAePayEnabled = false;
        this.useACAModule = false;
        this.usePayrollModule = false;
        this.useYearRound = false;
        this.availablePTO = null;
		this.availableSickTime = null;
        this.messageCenterAlerts = null;
        this.divisionCaption = null;
		this.division = null;
		this.email = null;
    }
}

export class AgentFilterPayload {
    agentID: number;
    dateRangeDropDownEnum?: number;
    systemNumber?: number;
    includeDisabled?: boolean;

    constructor() {
        this.agentID = null;
        this.dateRangeDropDownEnum = 0;
        this.systemNumber = DbCommon.emptyInt;
        this.includeDisabled = false;
    }
}

export class SupervisedAgentList {
    supervisedAgents: SupervisedAgent[];
}

export class SupervisedAgent {
    agentID: number;
    name: string;

    constructor() {
        this.agentID = null;
        this.name = '';
    }
}

export class AgentUserFilterPayload {
    companyID?: number;
    includeDisabled?: boolean;
    agentID?: number;

    constructor() {
        this.companyID = 0;
        this.includeDisabled = false;
        this.agentID = 0;
    }
}

/**
 * Added name for the constructor and not used for API calls
 */
export class AgentUser {
    firstName: string;
    middleName: string;
    lastName: string;
    address: string;
    city: string;
    state: string;
    fax: string;
    zipCode: string;
    email: string;
    phone: string;
    id: number;
    agentID: number;
    disabled: boolean;
    uid: string;
    resetPassword: boolean;
    type: string;
    brokerID: number;
    name: string;

    constructor() {
        this.firstName = null;
        this.middleName = null;
        this.lastName = null;
        this.address = null;
        this.city = null;
        this.state = null;
        this.fax = null;
        this.zipCode = null;
        this.email = null;
        this.phone = null;
        this.id = 0;
        this.agentID = 0;
        this.disabled = false;
        this.uid = null;
        this.resetPassword = false;
        this.type = null;
        this.brokerID = 0;
        this.name = `${this.firstName} ${this.lastName}`;
    }
}

export class AgentsManageDisabled {
    disabled: number[];
    enabled: number[];

    constructor() {
        this.disabled = new Array<number>();
        this.enabled = new Array<number>();
    }
}

export class CompanyAgentsSelected {
    companyID: number;
    agentIDs: number[];

    constructor() {
        this.companyID = 0;
        this.agentIDs = new Array<number>();
    }
}

export class AgentCompaniesSelected {
    agentID: number;
    companyIDs: number[];

    constructor() {
        this.agentID = 0;
        this.companyIDs = new Array<number>();
    }
}

export class AgentCarrierInfo {
    agentID: number;
    name: string;
    carrierID: number;
    carrierUID: string;
    carrierIDNumber: string;
    udF1: string;
    udF2: string;

    constructor() {
        this.agentID = 0;
        this.name = null;
        this.carrierID = 0;
        this.carrierUID = null;
        this.carrierIDNumber = null;
        this.udF1 = null;
        this.udF2 = null;
    }
}

export class AgentCarrierInfoPayload {
    carrierInfos: AgentCarrierInfo[];

    constructor() {
        this.carrierInfos = new Array<AgentCarrierInfo>();
    }
}

export class AgentCreateMemberModel {
    showErid: boolean;
    showPayrollNumber: boolean;
    availableDivision: AgentMemberDemographic[];
    availableEEClass1: AgentMemberDemographic[];
    availableEEClass2: AgentMemberDemographic[];
    availableEEClass3: AgentMemberDemographic[];
    availableEEClass4: AgentMemberDemographic[];
    availableEEClass5: AgentMemberDemographic[];
    availableCompanyLocations: AgentMemberDemographic[];
    availableDepartment: AgentMemberDemographic[];
    availablePosition: AgentMemberDemographic[];
    availableEmploymentStatuses: AgentMemberDemographic[];
    displayEEClass1Caption: string;
    displayEEClass2Caption: string;
    displayEEClass3Caption: string;
    displayEEClass4Caption: string;
    displayEEClass5Caption: string;
    displayDivisionCaption: string;
    displayCompanyLocationCaption: string;
    displayDepartmentCaption: string;
    displayPositionCaption: string;
    displayUDF1Caption: string;
    displayUDF2Caption: string;
    displayUDF3Caption: string;
    displayUDF4Caption: string;
    displayUDF5Caption: string;
    showEEClass1: boolean;
    showEEClass2: boolean;
    showEEClass3: boolean;
    showEEClass4: boolean;
    showEEClass5: boolean;
    showDivision: boolean;
    showCompanyLocation: boolean;
    showDepartment: boolean;
    showPosition: boolean;
    showSalary1: boolean;
    showSalary2: boolean;
    showSalary3: boolean;
    showUdf1: boolean;
    showUdf2: boolean;
    showUdf3: boolean;
    showUdf4: boolean;
    showUdf5: boolean;

    constructor() {
        this.showErid = false;
        this.showPayrollNumber = false;
        this.availableDivision = new Array<AgentMemberDemographic>();
        this.availableEEClass1 = new Array<AgentMemberDemographic>();
        this.availableEEClass2 = new Array<AgentMemberDemographic>();
        this.availableEEClass3 = new Array<AgentMemberDemographic>();
        this.availableEEClass4 = new Array<AgentMemberDemographic>();
        this.availableEEClass5 = new Array<AgentMemberDemographic>();
        this.availableCompanyLocations = new Array<AgentMemberDemographic>();
        this.availableDepartment = new Array<AgentMemberDemographic>();
        this.availablePosition = new Array<AgentMemberDemographic>();
        this.availableEmploymentStatuses = new Array<AgentMemberDemographic>();
        this.displayEEClass1Caption = '';
        this.displayEEClass2Caption = '';
        this.displayEEClass3Caption = '';
        this.displayEEClass4Caption = '';
        this.displayEEClass5Caption = '';
        this.displayDivisionCaption = '';
        this.displayCompanyLocationCaption = '';
        this.displayDepartmentCaption = '';
        this.displayPositionCaption = '';
        this.displayUDF1Caption = '';
        this.displayUDF2Caption = '';
        this.displayUDF3Caption = '';
        this.displayUDF4Caption = '';
        this.displayUDF5Caption = '';
        this.showEEClass1 = false;
        this.showEEClass2 = false;
        this.showEEClass3 = false;
        this.showEEClass4 = false;
        this.showEEClass5 = false;
        this.showDivision = false;
        this.showCompanyLocation = false;
        this.showDepartment = false;
        this.showPosition = false;
        this.showSalary1 = false;
        this.showSalary2 = false;
        this.showSalary3 = false;
        this.showUdf1 = false;
        this.showUdf2 = false;
        this.showUdf3 = false;
        this.showUdf4 = false;
        this.showUdf5 = false;
    }
}

export class AgentCreateMemberPayload {
    companyID: number;
    erid: string;
    payrollNumber: string;
    homeEmail: string;
    homePhone: string;
    cellPhone: string;
    dateOfHire: string | Date;
    dateOfBirth: string | Date;
    firstName: string;
    middleName: string;
    lastName: string;
    workJobTitle: string;
    workEmail: string;
    workPhone: string;
    homeAddressLine1: string;
    homeAddressLine2: string;
    homeCity: string;
    homeState: string;
    homeZipCode: string;
    gender: string;
    ssnDecrypted: string;
    division: number;
    eEClass1: number;
    eEClass2: number;
    eEClass3: number;
    eEClass4: number;
    eEClass5: number;
    companyLocation: number;
    department: number;
    position: number;
    employmentStatus: number;
    salary1: number;
    salary1Frequency: string;
    salary2: number;
    salary2Frequency: string;
    salary3: number;
    salary3Frequency: string;
    udf1: string;
    udf2: string;
    udf3: string;
    udf4: string;
    udf5: string;
    workHours: number;

    constructor() {
        this.companyID = 0;
        this.erid = '';
        this.payrollNumber = '';
        this.homeEmail = '';
        this.homePhone = '';
        this.cellPhone = '';
        this.dateOfHire = '';
        this.dateOfBirth = '';
        this.firstName = '';
        this.middleName = '';
        this.lastName = '';
        this.workJobTitle = '';
        this.workEmail = '';
        this.workPhone = '';
        this.homeAddressLine1 = '';
        this.homeAddressLine2 = '';
        this.homeCity = '';
        this.homeState = '';
        this.homeZipCode = '';
        this.gender = '';
        this.ssnDecrypted = '';
        this.division = 0;
        this.eEClass1 = 0;
        this.eEClass2 = 0;
        this.eEClass3 = 0;
        this.eEClass4 = 0;
        this.eEClass5 = 0;
        this.companyLocation = 0;
        this.department = 0;
        this.position = 0;
        this.employmentStatus = 0;
        this.salary1 = 0;
        this.salary1Frequency = null;
        this.salary2 = 0;
        this.salary2Frequency = null;
        this.salary3 = 0;
        this.salary3Frequency = null;
        this.udf1 = null;
        this.udf2 = null;
        this.udf3 = null;
        this.udf4 = null;
        this.udf5 = null;
        this.workHours = null;
    }
}

export class AgentMemberDemographic {
    id: number;
    name: string;

    constructor() {
        this.id = 0;
        this.name = null;
    }
}

export class AgentCreateMemberResponse {
    systemNumber: number;
    memberName: string;
    companyName: string;
    isVerified: boolean;

    constructor() {
        this.systemNumber = 0;
        this.memberName = null;
        this.companyName = null;
        this.isVerified = false;
    }
}